import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PlatformGroupService {

  platformGroup: Array<{ id: string; name: string, color: string }> = []

  private endpoint = environment.endpoint;

  constructor(
    private http: HttpClient
  ) { }


  getAllPlatformGroup(filters: any) {
    return firstValueFrom(this.http.get(`${this.endpoint}/platform-group`, { params: filters }));
  }
}
